import { compose } from "./functional.js";
const notWithNegIndex = s => s + `:not([tabindex="-1"])`;
const notDisabled = s => s + ":not([disabled])";
const notHidden = s => s + ":not([hidden])";

const basicElements = [
  "button",
  'input:not([type="hidden"])',
  "select",
  "textarea",
  "text-area",
  "a[href]",
  "summary"
];

export const tabbableSelector = basicElements
  .map(compose(notWithNegIndex, notDisabled, notHidden))
  .concat([`[tabindex="0"]`])
  .join(", ");

export const tabbableSelectorIncludingNegIndexed = basicElements
  .map(compose(notDisabled, notHidden))
  .concat([`[tabindex]`])
  .join(", ");
